module.exports = __webpack_public_path__ + "static/media/googleplay.8c5b7a81.svg";